export function init(store, p, x) {
//    console.log('Entering init store=',store,'p=',p,'x=',x);
//    console.log('Exiting init x=',x);
    return x;
}
